import { createSlice } from '@reduxjs/toolkit';
import { EMPTY_DATA_SEARCH_CONTRACT_LABOR_REFUSE } from './constant/emptyData';

const initialState = {
    search: {
        ...EMPTY_DATA_SEARCH_CONTRACT_LABOR_REFUSE
    }
};

export const contractLaborRefuseSlice = createSlice({
    name: 'contractLaborRefuse',
    initialState,
    reducers: {
        searchContractLaborRefuse: (state, action) => {
            state.search = action.payload;
        },
        searchContractLaborRefusePageFirst: (state, action) => {
            state.search.page = 1;
        },
    },
})


// Action creators are generated for each case reducer function
const { reducer, actions } = contractLaborRefuseSlice;
export const { searchContractLaborRefuse, searchContractLaborRefusePageFirst } = actions

export const selectSearchContractLaborRefuse = (state) => state?.features?.contractLaborRefuse?.search

export default reducer


